/* ============================================================
   Southern Xchange — theme.js
   Lightweight, dependency-free storefront behaviour.
   ============================================================ */
(function () {
  "use strict";

  var money = window.SGC && window.SGC.moneyFormat ? window.SGC.moneyFormat : "${{amount}}";

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return money.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ---------- Mobile menu drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector("[data-drawer]");
    if (!drawer) return;
    var openBtns = document.querySelectorAll("[data-drawer-open]");
    var closeEls = drawer.querySelectorAll("[data-drawer-close]");

    function open() {
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }
    function close() {
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
    openBtns.forEach(function (b) { b.addEventListener("click", open); });
    closeEls.forEach(function (b) { b.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  }

  /* ---------- Search toggle (mobile) ---------- */
  function initSearchToggle() {
    var toggle = document.querySelector("[data-search-toggle]");
    var panel = document.querySelector("[data-search-panel]");
    if (!toggle || !panel) return;
    toggle.addEventListener("click", function () {
      var hidden = panel.hasAttribute("hidden");
      if (hidden) {
        panel.removeAttribute("hidden");
        var input = panel.querySelector("input[type=search], input[name=q]");
        if (input) input.focus();
      } else {
        panel.setAttribute("hidden", "");
      }
    });
  }

  /* ---------- Quantity selectors ---------- */
  function initQty() {
    document.querySelectorAll("[data-qty]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      if (!input) return;
      wrap.querySelectorAll("[data-qty-btn]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = btn.getAttribute("data-qty-btn") === "plus" ? 1 : -1;
          var val = parseInt(input.value, 10) || 1;
          val = Math.max(1, val + step);
          input.value = val;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  function initGallery() {
    var gallery = document.querySelector("[data-gallery]");
    if (!gallery) return;
    var main = gallery.querySelector("[data-gallery-main] img");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!main) return;
        main.src = thumb.getAttribute("data-full");
        main.srcset = "";
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
          t.setAttribute("aria-current", "false");
        });
        thumb.setAttribute("aria-current", "true");
      });
    });
  }

  /* ---------- Cart count refresh ---------- */
  function refreshCartCount() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle("hidden", cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  /* ---------- AJAX add to cart (quick add + product form) ---------- */
  function initAddToCart() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("[data-add-btn]");
        var original = btn ? btn.textContent : "";
        if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(serialize(form))
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw d; });
            return r.json();
          })
          .then(function () {
            refreshCartCount();
            if (btn) { btn.textContent = "Added ✓"; }
            setTimeout(function () {
              if (btn) { btn.disabled = false; btn.textContent = original; }
            }, 1400);
          })
          .catch(function (err) {
            if (btn) { btn.disabled = false; btn.textContent = original; }
            alert((err && err.description) || "Sorry, this item could not be added.");
          });
      });
    });
  }

  function serialize(form) {
    var data = { items: [] };
    var id = form.querySelector("[name=id]");
    var qty = form.querySelector("[name=quantity]");
    data.items.push({
      id: id ? parseInt(id.value, 10) : null,
      quantity: qty ? parseInt(qty.value, 10) || 1 : 1
    });
    return data;
  }

  /* ---------- Cart line item updates ---------- */
  function initCartPage() {
    var cart = document.querySelector("[data-cart-page]");
    if (!cart) return;
    cart.addEventListener("click", function (e) {
      var remove = e.target.closest("[data-cart-remove]");
      if (remove) {
        e.preventDefault();
        updateLine(remove.getAttribute("data-cart-remove"), 0);
      }
    });
    cart.addEventListener("change", function (e) {
      var input = e.target.closest("[data-cart-qty]");
      if (input) {
        updateLine(input.getAttribute("data-cart-qty"), parseInt(input.value, 10) || 0);
      }
    });

    function updateLine(key, quantity) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initDrawer();
    initSearchToggle();
    initQty();
    initGallery();
    initAddToCart();
    initCartPage();
    refreshCartCount();
  });
})();
